import React from "react";
import "../../styles/Feast.scss";
import HaloHalo from "../../components/assets/Halo-Halo.jpg"
import Adobo from "../../components/assets/adobo.jpg"

export default function Feast() {
  return (
    <section className="feast-section">
      <div className="feast-container">
        <h2 className="feast-title">A Feast for Every Traveler</h2>

        <p className="feast-description">
          Filipino cuisine is a journey in itself — a fusion of flavors inspired
          by Asian roots and Spanish influences. Don’t miss local favorites like
          adobo, sinigang, and lechon, or sweet treats like halo-halo and
          bibingka. Wherever you go, every meal comes with a smile — and maybe
          even a karaoke invitation.
        </p>

        <div className="feast-images">
          <div className="feast-image-block">
            <img
              src={HaloHalo}
              alt="Halo-halo"
              className="feast-image"
            />
            <div className="feast-label">Halo-halo</div>
          </div>

          <div className="feast-image-block">
            <img
              src={Adobo}
              alt="Adobo"
              className="feast-image"
            />
            <div className="feast-label">Adobo</div>
          </div>
        </div>
      </div>
    </section>
  );
}
